export default "__VITE_ASSET__BC3XU7yn__"